import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class ScrollFunc {
    constructor() {
        //this.init();
    }

    init() {
        window.addEventListener('load', this.onScroll.bind(this));
    }

    onScroll() {
        const revealElm = [...document.querySelectorAll('.js-scrollreveal')];

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: 'top 85%',
                //markers: true,
                onEnter: () => {
                    el.classList.add('-reveal');
                },
            });
        });
    }

    refreshScroll() {
        ScrollTrigger.refresh();
    }
}
